import reducer from './dialogSendSlip.reducer';
import * as action from './dialogSendSlip.action';
import * as selector from './dialogSendSlip.selector';
import * as constant from './dialogSendSlip.constant';
import initialState from './dialogSendSlip.initialState';
import subscriber from './dialogSendSlip.subscriber';
import saga from './dialogSendSlip.saga';

export default {
  reducer,
  action,
  constant,
  selector,
  initialState,
  subscriber,
  saga,
  name: constant.NAME,
};
